import {IonFab, IonFabButton, IonIcon} from "@ionic/react";
import {settingsOutline} from "ionicons/icons";
import {nativeAppAdapter} from "app/employee/nativeApp/FSAcademyAndroidAdapter";
import {linkEmplNativeNotificationSettings} from "app/employee/core/employeeLinks";

export const NativeNotificationSettingsFab = () => {
  if (nativeAppAdapter.isRunningInAndroidApp()) {
    return (
      <IonFab horizontal="end" slot="fixed" vertical="bottom">
        <IonFabButton
          color="light"
          routerDirection="forward"
          routerLink={linkEmplNativeNotificationSettings()}
          size="small"
        >
          <IonIcon icon={settingsOutline} />
        </IonFabButton>
      </IonFab>
    );
  } else {
    return null;
  }
};
